import { surChargeTypeDropdownOption, uomDropdownOption } from "presentation/constant/DropDownOptions/StaticDropdownOptions";
import { ProposalCopyingForRecalConstant } from "presentation/constant/ProposalCopyingForRecal/ProposalCopyingForRecalConstant";
import { standardProposalTierRequiredFieldList } from "presentation/constant/StandardProposal/StandardProposalConstant";
import { useProposalCopyingForRecalVM } from "presentation/hook/ProposalCopyingForRecal/useProposalCopyingForRecalVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useProposalCopyingForRecalTracked } from "presentation/store/ProposalCopyingForRecal/ProposalCopyingForRecalProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import NumberInputComponent from "presentation/view/components/NumberInputComponent";
import { memo, useCallback, useMemo } from "react";
import { FieldType, IconButton, IFieldValue } from "veronica-ui-component/dist/component/core";
import { SidebarActionCross, Sidebarheader, SidebarTitle } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";


const TariffItemTierEditPanel = () => {
    const SCREEN_CONSTANT = ProposalCopyingForRecalConstant.Table;
    const [proposalCopyingForRecalState] = useProposalCopyingForRecalTracked();
    const proposalCopyingForRecalVM = useProposalCopyingForRecalVM();
    const { currentEditItemTier, isShowEditTierPanel, masterState } = proposalCopyingForRecalState;
    const { isSaveClicked, allFormState } = masterState;
    const messageBarVM = useMessageBarVM();

    const handleSave = useCallback(() => {
        // if (currentEditItemTier.minimum === null) {
        //     messageBarVM.showError("MINIMUM RATE is mandatory.");
        //     return;
        // }
        // if (currentEditItemTier.rate === null) {
        //     messageBarVM.showError("RATE is mandatory.");
        //     return;
        // }
        // if (!currentEditItemTier.uom) {
        //     messageBarVM.showError("UOM is mandatory.");
        //     return;
        // }
        // if (!currentEditItemTier.forevery) {
        //     messageBarVM.showError("FOR EVERY is mandatory.");
        //     return;
        // }
        // if (!currentEditItemTier.cycle) {
        //     messageBarVM.showError("CYCLE is mandatory.");
        //     return;
        // }
        if (Number(currentEditItemTier.minimum) > Number(currentEditItemTier.rate)) {
            messageBarVM.showError("The Minimum should not be larger than Rate.");
            return;
        }
        if ((!currentEditItemTier.surcharge && currentEditItemTier.surchargeType)
            || (currentEditItemTier.surcharge && !currentEditItemTier.surchargeType)) {
            messageBarVM.showError("Please input SURCHARGE and  SURCHARGE TYPE together");
            return;
        }
        if ((!currentEditItemTier.additionalUom && currentEditItemTier.additionalRate)
            || (currentEditItemTier.additionalUom && !currentEditItemTier.additionalRate)) {
            messageBarVM.showError("Please input ADDITIONAL UOM and  ADDITIONAL RATE together");
            return;
        }
        if (Number(currentEditItemTier.rate) > Number(99999999.00) || Number(currentEditItemTier.rate) < Number(-99999999.00)) {
            messageBarVM.showError("RATE should be range from -99,999,999.00 to 99,999,999.00.");
            return;
        }
        if (Number(currentEditItemTier.minimum) > Number(99999999.00) || Number(currentEditItemTier.minimum) < Number(-99999999.00)) {
            messageBarVM.showError("MINIMUM RATE should be range from -99,999,999.00 to 99,999,999.00.");
            return;
        }
        if (Number(currentEditItemTier.additionalRate) > Number(99999999.00) || Number(currentEditItemTier.additionalRate) < Number(-99999999.00)) {
            messageBarVM.showError("ADDITIONAL RATE should be range from -99,999,999.00 to 99,999,999.00.");
            return;
        }
        if (Number(currentEditItemTier.surcharge) > Number(99999999.00) || Number(currentEditItemTier.surcharge) < Number(0)) {
            messageBarVM.showError("SURCHARGE should be range from 0.00 to 99,999,999.00.");
            return;
        }
        proposalCopyingForRecalVM.onSaveClicked();
        proposalCopyingForRecalVM.onTempSaveItemTier(currentEditItemTier);
        return;
    }, [currentEditItemTier, messageBarVM, proposalCopyingForRecalVM]);

    const handleCancel = useCallback(() => {
        proposalCopyingForRecalVM.cancelEdit();
    }, [proposalCopyingForRecalVM]);

    const onNumberFieldChange = useCallback((e: any, fieldName: string, fieldValue: any) => {
        proposalCopyingForRecalVM.onTierFieldChange(fieldName, fieldValue);
    }, [proposalCopyingForRecalVM]);

    const memoCycle = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "190px", marginBottom: "10px" }}>
            {/* <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={false}
                isShowOptional={true}
                readOnlyValue={currentEditItemTier?.cycle?.toString() || ''}
                fieldValue={currentEditItemTier?.cycle?.toString()}
                fieldLabel={SCREEN_CONSTANT.CYCLE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'cycle'}
                maxLength={60}
                requiredFieldList={standardProposalTierRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    proposalCopyingForRecalVM.onTierFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} /> */}
            <NumberInputComponent
                label={SCREEN_CONSTANT.CYCLE}
                maxLength={10}
                fieldName={"cycle"}
                value={currentEditItemTier?.cycle ?? ''}
                errorMessage={allFormState ? allFormState["cycle"] ?? "" : ""}
                allowNegative={false}
                disabled={false}
                decimalPlaces={0}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />
        </div>
        , [SCREEN_CONSTANT.CYCLE, allFormState, currentEditItemTier?.cycle, onNumberFieldChange])

    const memoForEvery = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "190px", marginBottom: "10px" }}>
            {/* <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={false}
                isShowOptional={true}
                readOnlyValue={currentEditItemTier?.forevery?.toString() || ''}
                fieldValue={currentEditItemTier?.forevery?.toString()}
                fieldLabel={SCREEN_CONSTANT.FOR_EVERY}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'forevery'}
                maxLength={60}
                requiredFieldList={standardProposalTierRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    proposalCopyingForRecalVM.onTierFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} /> */}
            <NumberInputComponent
                label={SCREEN_CONSTANT.FOR_EVERY}
                maxLength={10}
                fieldName={"forevery"}
                value={currentEditItemTier?.forevery ?? ''}
                errorMessage={allFormState ? allFormState["forevery"] ?? "" : ""}
                allowNegative={false}
                disabled={false}
                decimalPlaces={0}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />
        </div>
        , [SCREEN_CONSTANT.FOR_EVERY, allFormState, currentEditItemTier?.forevery, onNumberFieldChange])

    const memoUom = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "190px", marginBottom: "10px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={false}
                isShowOptional={true}
                readOnlyValue={currentEditItemTier?.uom || ''}
                fieldValue={currentEditItemTier?.uom}
                fieldLabel={SCREEN_CONSTANT.UOM}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'uom'}
                maxLength={60}
                options={uomDropdownOption}
                requiredFieldList={standardProposalTierRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    proposalCopyingForRecalVM.onTierFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.UOM, allFormState, currentEditItemTier?.uom, isSaveClicked, proposalCopyingForRecalVM])

    const memoRate = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "190px", marginBottom: "10px" }}>
            <NumberInputComponent
                label={SCREEN_CONSTANT.RATE}
                maxLength={60}
                fieldName={"rate"}
                value={currentEditItemTier?.rate ?? ''}
                errorMessage={allFormState ? allFormState["rate"] ?? "" : ""}
                disabled={false}
                decimalPlaces={2}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />
        </div>
        , [SCREEN_CONSTANT.RATE, allFormState, currentEditItemTier?.rate, onNumberFieldChange])

    const memoMinimun = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "190px", marginBottom: "10px" }}>
            <NumberInputComponent
                label={SCREEN_CONSTANT.MINIMUM}
                maxLength={60}
                fieldName={"minimum"}
                value={currentEditItemTier?.minimum ?? ''}
                errorMessage={allFormState ? allFormState["minimum"] ?? "" : ""}
                disabled={false}
                decimalPlaces={2}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />
        </div>
        , [SCREEN_CONSTANT.MINIMUM, allFormState, currentEditItemTier?.minimum, onNumberFieldChange])

    const memosurCharge = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "190px", marginBottom: "10px" }}>
            <NumberInputComponent
                label={SCREEN_CONSTANT.SURCHARGE}
                maxLength={60}
                fieldName={"surcharge"}
                value={currentEditItemTier?.surcharge ?? ''}
                errorMessage={allFormState ? allFormState["surcharge"] ?? "" : ""}
                disabled={false}
                decimalPlaces={2}
                optional={true}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />
        </div>
        , [SCREEN_CONSTANT.SURCHARGE, allFormState, currentEditItemTier?.surcharge, onNumberFieldChange])

    const memoSurChargeType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "190px", marginBottom: "10px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={false}
                isShowOptional={true}
                readOnlyValue={currentEditItemTier?.surchargeType || ''}
                fieldValue={currentEditItemTier?.surchargeType}
                fieldLabel={SCREEN_CONSTANT.SURCHARGE_TYPE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'surchargeType'}
                maxLength={60}
                options={surChargeTypeDropdownOption}
                requiredFieldList={standardProposalTierRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    proposalCopyingForRecalVM.onTierFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.SURCHARGE_TYPE, allFormState, currentEditItemTier?.surchargeType, isSaveClicked, proposalCopyingForRecalVM])

    const memoAdditionalRate = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "190px", marginBottom: "10px" }}>
            <NumberInputComponent
                label={SCREEN_CONSTANT.ADDITIONAL_RATE}
                maxLength={60}
                fieldName={"additionalRate"}
                value={currentEditItemTier?.additionalRate ?? ''}
                errorMessage={allFormState ? allFormState["additionalRate"] ?? "" : ""}
                disabled={false}
                decimalPlaces={2}
                optional={true}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />
        </div>
        , [SCREEN_CONSTANT.ADDITIONAL_RATE, allFormState, currentEditItemTier?.additionalRate, onNumberFieldChange])

    const memoAdditionalUom = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "190px", marginBottom: "10px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={false}
                isShowOptional={true}
                readOnlyValue={currentEditItemTier?.additionalUom || ''}
                fieldValue={currentEditItemTier?.additionalUom}
                fieldLabel={SCREEN_CONSTANT.ADDITIONAL_UOM}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'additionalUom'}
                maxLength={60}
                options={uomDropdownOption}
                requiredFieldList={standardProposalTierRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    proposalCopyingForRecalVM.onTierFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.ADDITIONAL_UOM, allFormState, currentEditItemTier?.additionalUom, isSaveClicked, proposalCopyingForRecalVM])

    return <div className="side-form-content-left-wrapper" style={{ height: "40vh", maxHeight: "40vh", overflow: "visible", padding: "5px" }}>

        <div className={'flex-row'}>
            <div className={'flex-row-item flex-row-item-full-width'}>
                <Sidebarheader>
                    <SidebarTitle>
                        {isShowEditTierPanel && "Edit " + SCREEN_CONSTANT.TIER_VALUE}
                    </SidebarTitle>
                    <SidebarActionCross>
                        <IconButton
                            fileName="Icon-cross" size="medium" toolTipText='Close' toolTipArrow={false} onClick={handleCancel} />
                        <IconButton
                            fileName="Icon-tick" size="medium" toolTipText='Save' toolTipArrow={false} onClick={handleSave} />
                    </SidebarActionCross>
                </Sidebarheader>
            </div>
        </div>

        <div className={'add-edit-form'} style={{ height: '30vh', maxHeight: '30vh', overflow: 'visible', zIndex: '100' }}>
            <div className="flex-row-auto">
                <div className={'flex-row-item'}>
                    <CriteriaItemContainer>
                        {memoCycle}
                        {memoForEvery}
                        {memoUom}
                    </CriteriaItemContainer>
                    <CriteriaItemContainer>
                        {memoRate}
                        {memoMinimun}
                        {memosurCharge}
                    </CriteriaItemContainer>
                    <CriteriaItemContainer>
                        {memoSurChargeType}
                        {memoAdditionalRate}
                        {memoAdditionalUom}
                    </CriteriaItemContainer>
                </div>
            </div>
        </div>
    </div>;
}

export default memo(TariffItemTierEditPanel);